module.exports = __webpack_public_path__ + "img/61.f5306d2b.jpg";